import React, { useState } from 'react';

// components
import AlcoholEducation from './AlcoholEducation';
import AlcoholMemo from './AlcoholMemo';
import AlcoholDiary from './AlcoholDiary';
import AlcoholCheck from './AlcoholCheck';
import AlcoholMessage from './AlcoholMessage';


function AlcoholPatientReport({patientData}) {
	const [selectedTag, setSelectedTag] = useState("diary");
	const reportTag = [
		{ key: 'diary', value: '금주 일지', component: <AlcoholDiary setSelectedTag={setSelectedTag}/> },
		{ key: 'education', value: '교육 현황', component: <AlcoholEducation patientData={patientData}/> },
		{ key: 'survey', value: '음주 점검', component: <AlcoholCheck patientData={patientData} /> },
		{ key: 'message', value: '메시지 이력', component: <AlcoholMessage/> }
	];

	return (
		<div className="patientManageDetail__report">
			<div className="reportTag">
				{reportTag.map((item) => {
					return (
						<div
							key={item.key}
							className="reportTagItem"
							role="none"
							onClick={() => setSelectedTag(item.key)}
							style={{
								background: selectedTag === item.key ? '#aed0db' : 'white',
								border: selectedTag === item.key ? '0.5px solid transparent' : '0.5px solid #174a84',
							}}
						>
							{item.value}
						</div>
					);
				})}
			</div>
			<div className="reportContent">
				<div className="reportContent__patientResult">
					{reportTag.filter(e=>e.key===selectedTag)[0].component}
					<div className='reportContent_sideSection'>
						<AlcoholMemo />
					</div>
				</div>			
			</div>
		</div>
	);
}

export default AlcoholPatientReport;
